import React, { useEffect, useState } from "react";
import ModalComponent from "../../../common/ModalComponent";
import RichTextEditor from "../../../common/RichTextEditor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faSave } from "@fortawesome/free-solid-svg-icons";
import { saveWorkflowExecutionResultAPI } from "../../../../service/ai-model.service";
import { useAppContext } from "../../../../context/app.context";
import constant, { ToastType } from "../../../../helper/constant";
import { faDownload } from "@fortawesome/free-solid-svg-icons/faDownload";
import { generateOverviewWord } from "../../../../helper/helper";

const GenerativePrediction = ({ id, name, executionId, showModal, setShowModal, data }) => {
    const [content, setContent] = useState({ gpt4_response: '', original_response: '' });
    const { showAlert } = useAppContext();
    const [edit, setEdit] = useState(false);

    useEffect(() => {
        if (data) {
            setContent({ gpt4_response: data.gpt4_response || '', original_response: data.original_response || '' });
        }
    }, [data])

    const onEditPressed = () => {
        if (edit) {
            const payload = {
                nodeId: id,
                executionId,
                ...content,
            }
            saveWorkflowExecutionResultAPI(payload)
                .then((res) => { })
                .catch((err) => { showAlert(constant.MESSAGES.COMMON_ERROR_MESSAGE, ToastType.ERROR) });
        }
        setEdit(!edit);
    }

    const onDownload = () => {
        generateOverviewWord(name, 'prediction-document-ref');
    }

    const renderAction = () => {
        return (
            <div className="d-flex gap-2 justify-content-end">
                <button className={`btn btn-primary align-self-end btn-primary`} type="button" onClick={() => onDownload()} >
                    <span><FontAwesomeIcon icon={faDownload} /></span>
                    <span className="px-1">Download</span>
                </button>
                <button className={`btn btn-primary align-self-end ${edit ? 'btn-success' : 'btn-secondary'}`} type="button" onClick={() => onEditPressed()} >
                    <span className="px-1">{edit ? 'Save' : 'Edit'}</span>
                    <span><FontAwesomeIcon icon={edit ? faSave : faPencil} /></span>
                </button>
            </div>
        )
    }

    const renderOriginalContent = () => {
        if (content.original_response) {
            return (
                <div className="ai-generative-data d-flex flex-column gap-1">
                    {edit && (
                        <div className="d-flex gap-2 justify-content-between align-items-start">
                            <div className="d-flex flex-column gap-2 w-50">
                                <h6 className="text-xl mb-2">Editor</h6>
                                <RichTextEditor value={content.original_response} onChange={(original_response) => setContent({ ...content, original_response })} />
                            </div>
                            <div className="d-flex flex-column gap-2 w-50">
                                <h6 className="font-bold mb-2">Output:</h6>
                                <div className="border p-2" dangerouslySetInnerHTML={{ __html: content.original_response }} />
                            </div>
                        </div>
                    )}
                    {!edit && <p className="m-0 p-0 white-space-break" id='prediction-document-ref' dangerouslySetInnerHTML={{ __html: content.original_response }}></p>}
                </div>
            )
        }

        return (
            <div className="ai-generative-data d-flex flex-column gap-1">
                <p className="m-0 p-0 text-align-center">No data available</p>
            </div>
        )
    }

    const renderTabs = () => {
        return (
            <>
                <h3>Content</h3>
                {renderOriginalContent()}
            </>
        )
    }

    const render = () => {
        return (
            <ModalComponent
                full
                title={name}
                show={showModal}
                handleClose={() => {
                    setShowModal(false);
                }}
            >
                <div className="d-flex flex-column gap-2">
                    {renderAction()}
                    {renderTabs()}
                </div>

            </ModalComponent>
        )
    }
    return render();
}
export default GenerativePrediction